//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchUtils from '~/mixins/search/search-utils'

export default {
  name: 'SearchOtherLocations',
  props: {
    isDestination: {
      type: Boolean,
      default: false
    }
  },
  mixins: [searchUtils],
  computed: {
    routeType () {
      return this.isDestination ? 'destination-location' : 'search'
    },
    getLocations () {
      return this.searchFilters?.locations
    },
    hasLocations () {
      return !!this.getLocations?.length
    },
    getParentLocations () {
      let title = (this.location.location)[this.location.type] || 'Tubber'
      if (this.locationsFull && this.locationsFull.length) {
        title = ''
        this.locationsFull.forEach((location, i) => {
          if (location) {
            title += (i > 0 ? ', ' : '') + (location.location)[location.type]
          }
        })
      }
      return title
    }
  }
}
